import { getRequest } from "../http/HttpRequest";
import { ProductType } from "./types";

const getAllServices = async (organizationId: string) => {
  try {
    // do products request
    const response = await getRequest(
      "products?organizationId=" + organizationId
    );

    // get products
    const products: ProductType[] = !!response && response.data.products;

    return products;
  } catch (e) {
    return undefined;
  }
};

export { getAllServices };
